import { render, staticRenderFns } from "./DeliveredReportComponent.vue?vue&type=template&id=3072b5b4&scoped=true"
import script from "./DeliveredReportComponent.vue?vue&type=script&lang=js"
export * from "./DeliveredReportComponent.vue?vue&type=script&lang=js"
import style0 from "./DeliveredReportComponent.vue?vue&type=style&index=0&id=3072b5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072b5b4",
  null
  
)

export default component.exports